"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pickRecommendationOriginalData = exports.makeCsvRowGenerator = exports.download = exports.saveAsCSV = exports.reviewCountCondition = exports.capitalize = exports.percentage = exports.round = exports.getPricingPlansNames = exports.avg = exports.formatNumber = void 0;
var end2end_1 = require("@hudled/end2end");
var date_fns_1 = require("date-fns");
var firestore_1 = require("firebase/firestore");
var pick_1 = __importDefault(require("lodash/pick"));
var currencyFormatter;
if (window.Intl) {
    currencyFormatter = new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: 'AUD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });
}
function formatNumber(intOrIntStr, currency) {
    var intStr = typeof intOrIntStr === 'number' ? intOrIntStr.toString() : intOrIntStr;
    if (!intStr)
        return intStr;
    var prefix = currency !== '' ? (0, end2end_1.getCurrencySymbol)(currency) : '';
    if (prefix === '$' && currencyFormatter) {
        return currencyFormatter.format(Math.round(parseFloat(intStr) * 100) / 100);
    }
    if (typeof intOrIntStr === 'number')
        return "".concat(prefix).concat(intOrIntStr.toLocaleString());
    if (intStr.match(/\$/))
        return intOrIntStr;
    return "".concat(prefix).concat(intOrIntStr);
}
exports.formatNumber = formatNumber;
var avg = function (arr) { return (arr === null || arr === void 0 ? void 0 : arr.length) > 0
    ? arr.reduce(function (total, num) { return total + num; }, 0) / arr.length
    : undefined; };
exports.avg = avg;
var getPricingPlansNames = function (serviceStat) { return (serviceStat.pricingPlans && Array.from(new Set(serviceStat.pricingPlans.map(function (_a) {
    var name = _a.name;
    return name;
}).filter(function (name) { return name; })))); };
exports.getPricingPlansNames = getPricingPlansNames;
var round = function (numberBeforeRounding) { return Math.round(numberBeforeRounding * 10) / 10; };
exports.round = round;
var percentage = function (num) { return num || num === 0 ? "".concat(Math.round(num * 100), "%") : ''; };
exports.percentage = percentage;
var capitalize = function (str) { return str ? str.charAt(0).toUpperCase() + str.slice(1) : ''; };
exports.capitalize = capitalize;
var reviewCountCondition = function (review) { return (review.usageLevel === 1 && review.hasAccess !== undefined)
    || (review.rejectRating === true && review.accessType !== undefined)
    || (review.usageLevel !== undefined && ((review.usageLevel <= 2 && review.accessType !== undefined)
        || !!review.formSubmitted
        || !!review.deferReview)); };
exports.reviewCountCondition = reviewCountCondition;
var saveAsCSV = function (csvStr, fileName) {
    var encodedUri = "data:text/csv;charset=utf-8,".concat(encodeURIComponent(csvStr));
    (0, exports.download)(encodedUri, fileName);
};
exports.saveAsCSV = saveAsCSV;
var download = function (uri, fileName) {
    var link = document.createElement('a');
    Object.assign(link.style, {
        width: '1px', height: '1px', position: 'absolute', visibility: 'hidden',
    });
    link.href = uri;
    link.target = '_blank';
    link.download = fileName || uri.split('/').reverse()[0];
    document.body.appendChild(link);
    link.click();
    setTimeout(function () {
        var _a;
        URL.revokeObjectURL(link.href);
        (_a = link.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(link);
    }, 100);
};
exports.download = download;
var makeCsvRowGenerator = function (headers, fieldMapper, noNull) { return (function (doc) {
    var docData = doc instanceof firestore_1.QueryDocumentSnapshot ? doc.data() : doc;
    return headers.map(function (field) {
        if (doc && field === 'id' && 'id' in doc) {
            return doc.id;
        }
        if (docData && fieldMapper && field in fieldMapper) {
            return fieldMapper[field](docData);
        }
        var value = docData === null || docData === void 0 ? void 0 : docData[field];
        if (noNull && value === null) {
            return '';
        }
        if (value instanceof firestore_1.Timestamp) {
            return (0, date_fns_1.format)(value.toDate(), 'yyyy-MM-dd');
        }
        if (Array.isArray(value) || typeof value === 'object') {
            return JSON.stringify(value);
        }
        return value;
    });
}); };
exports.makeCsvRowGenerator = makeCsvRowGenerator;
var RECO_ORIGINAL_DATA_FIELDS = ['potentialSavingsPercentage', 'potentialSavings', 'partnerOffering', 'dormantUsersCount',
    'multiServiceMeta'];
var pickRecommendationOriginalData = function (recommendation) { return (0, pick_1.default)(recommendation, RECO_ORIGINAL_DATA_FIELDS); };
exports.pickRecommendationOriginalData = pickRecommendationOriginalData;
